import {Resource} from "../actions/api";
import {useAppSelector} from "../hooks";
import {selectResources} from "../actions/userSlice";

export function hasResource(requiredResource: string, resources: Resource[]): boolean {
    for (const resource of resources) {
        if (resource.code.toLowerCase() === requiredResource.toLowerCase()) {
            return true
        }

        if (hasResource(requiredResource, resource.children)) {
            return true
        }
    }
    return false
}

export const useHasResources = (...requiredResources: string[]): boolean | undefined => {
    const resources = useAppSelector(selectResources)?.resources

    if (resources === undefined) {
        return undefined
    }

    return requiredResources.every(requiredResource => hasResource(requiredResource, resources))
}